import { Component, computed, inject, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { LocalizedDatePipe } from '~/app/pipes/LocalizedDate';
import { Dialog } from '~/app/services/dialog.service';

@Component({
  selector: 'gplus-confirm-unprepared-modal',
  imports: [TranslateModule],
  providers: [LocalizedDatePipe],
  templateUrl: './confirm-unprepared-modal.component.html'
})
export class ConfirmUnpreparedModalComponent {
  public dialog = input<Dialog>(null);
  private readonly localizedDatePipe = inject(LocalizedDatePipe);

  public timeWithStyle = computed(() => {
    const preparedTime = this.dialog()?.data?.prepared;
    if (!preparedTime) {
      return null;
    }

    return `<b>${this.localizedDatePipe.transform(preparedTime)}</b>`;
  });
}
